const LIMITED_CLUB_USER_ROLES = new Set(["coach", "dirigeant"]);
const FULL_ACCESS_ROLES = new Set(["admin"]);

function normalizeRoles(me) {
  return Array.isArray(me?.roles)
    ? me.roles.map((role) => String(role).toLowerCase())
    : [];
}

export function hasClubRole(me, role) {
  const normalizedRole = String(role).toLowerCase();
  return normalizeRoles(me).includes(normalizedRole);
}

export function hasRestrictedClubUserRole(me) {
  const roles = normalizeRoles(me);
  if (roles.some((role) => FULL_ACCESS_ROLES.has(role))) return false;
  return roles.some((role) => LIMITED_CLUB_USER_ROLES.has(role));
}

/** Sidebar: show while permissions are loading, hide only once we know access is denied. */
export function canSeeSidebarPlayersList(me, { loading = false } = {}) {
  if (loading) return true;
  if (!me) return false;
  // Athlete player accounts never see the club-wide players list.
  if (String(me.account_kind || "").toLowerCase() === "player") return false;
  if (hasClubRole(me, "player") && !hasClubRole(me, "admin")) return false;
  return !hasRestrictedClubUserRole(me);
}

/** Sidebar: show while permissions are loading, hide only once we know access is denied. */
export function canSeeSidebarUpdatePlayersInfos(me, { loading = false } = {}) {
  if (loading) return true;
  return (
    hasClubRole(me, "admin") ||
    hasClubRole(me, "physiotherapist") ||
    hasClubRole(me, "doctor")
  );
}
